import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './ui/App'
import * as Sentry from '@sentry/react'
import { replayIntegration } from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom'
import ShowCookieWarning from './ui/ShowCookieWarning'

Sentry.init({
  dsn: 'https://cfe374c9318697f368f8b41919261ac2@o4506361348358144.ingest.us.sentry.io/4508960516276224',
  environment: process.env.REACT_APP_SENTRY_STAGE,
  integrations: [
    replayIntegration(),
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      )
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

let localStorageAccessible = true

try {
  localStorage.setItem('test-cookie', 'cookie')
  localStorage.removeItem('test-cookie')
} catch (_e) {
  localStorageAccessible = false
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>{localStorageAccessible ? <App /> : <ShowCookieWarning />}</React.StrictMode>
)
